import { forwardRef, useCallback, useContext, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ModalDefaultProps } from 'components/Modal';
import { CommonUtilsContext } from 'contexts/commonUtils';
import { ModalTemplate } from 'components/ModalTemplate';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';

import { ScReferralProgram } from './styled';

import firstStep from '../../../assets/images/referralProgram/firstStep.webp';
import { Button } from 'components/buttons';
import { useNavigation } from 'react-navi';

export const ReferralProgramModal = forwardRef<
  HTMLDivElement,
  ModalDefaultProps
>(({ onClose }, ref) => {
  const { t } = useTranslation('referralSystem');
  const { navigate } = useNavigation();

  const { isMobileS } = useContext(CommonUtilsContext);

  const modalSettings: ModalTemplateSettings = useMemo(() => {
    return isMobileS
      ? { type: 'mobile', mode: { type: 'default' } }
      : {
          type: 'desktop',
          size: 'small',
          mode: { type: 'default' },
        };
  }, [isMobileS]);

  const handleNavigate = useCallback(() => {
    navigate('/profile-custom/referral-system');
    onClose && onClose();
  }, [navigate, onClose]);

  return (
    <ModalTemplate ref={ref} onClose={onClose} settings={modalSettings}>
      <ScReferralProgram>
        <img src={firstStep} className="character" alt="character" />
        <div className="title">{t('modal.title')}</div>
        <div className="wrapper-description">
          <div className="description">
            <Trans
              i18nKey="referralSystem:modal.firstDesctiption"
              components={{ strong: <strong /> }}
            />
          </div>
          <div className="description">{t('modal.secondDesctiption')}</div>
        </div>
        <div className="button-wrapper">
          <Button wide xLarge green onClick={handleNavigate}>
            {t('glossary:learnMore')}
          </Button>
        </div>
      </ScReferralProgram>
    </ModalTemplate>
  );
});
